<div class="schedule">
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/schedule_24dp.svg"
  ></ion-icon>
  <div>
    <p>{{ since() | dfnsFormat: 'ccc Pp' }}</p>
    <p>{{ until() | dfnsFormat: 'ccc Pp' }}</p>
  </div>
</div>
